import ReactDocx from "./ReactDocx";

export default ReactDocx;
